import "@arco-design/web-react/es/Select/style";
import _Select from "@arco-design/web-react/es/Select";
import { useSelect as useProjectCate } from '@/pages/projectCate/api';
import React from 'react';
export const SelectProjectCate = ({
  value,
  onChange,
  placeholder = '全部'
}) => {
  const {
    data,
    isLoading
  } = useProjectCate({
    params: {
      pageSize: 100,
      pageIndex: 1
    }
  });
  return /*#__PURE__*/React.createElement(_Select, {
    value: value,
    onChange: onChange,
    placeholder: placeholder,
    loading: isLoading,
    options: data ? data.data.items.map(v => ({
      label: v.name,
      value: v.id
    })) : [],
    allowClear: true
  });
};